import star from '../../assets/img/faq/f_star.png'
import polygon from '../../assets/img/faq/f_polygon.png'

import ExpandableItem from "../../components/ExpandableItem/ExpandableItem";



import "./faq.css"

function Faq() {
    const colorLine = '#C66B04';

    return (
        <div className="faq">

            <div className="faq-header-img">
                <img src={polygon} alt="" />
            </div>

            <div className="faq-header-conainer">
                <div className="faq-header-content">
                    <img src={star} alt="imagem Estrela" />
                    <h1>FAQ</h1>
                    <img src={star} alt="imagem Estrela" />
                </div>

            </div>

            <div>

                <div className="info">
                    <ExpandableItem
                        title="Qual é o propósito da Ripafactory?"
                        content="A Ripafactory tem como objetivo unir música, impacto social e sustentabilidade, transformando vidas através da fabricação de instrumentos musicais percussivos. Mais do que criar instrumentos, queremos criar oportunidades, ajudando a transformar vidas por meio da música."
                        borderColor={colorLine}
                    />

                    <ExpandableItem
                        title="Quais são os valores da Ripafactory?"
                        content="Buscamos excelência e inovação, garantindo que cada instrumento não apenas tenha qualidade, mas também gere um impacto positivo. Criamos um instrumento único que vai além do som – ele carrega propósito e impacto. Utilizamos Paricá, uma madeira de reflorestamento, assegurando responsabilidade ambiental. Nossa essência está na diversidade musical, conectando ritmos e histórias de diferentes culturas. Com um design patenteado, somos pioneiros no mercado, oferecendo uma proposta exclusiva e transformadora."
                        borderColor={colorLine}
                    />

                    <ExpandableItem
                        title="Como a Ripafactory contribui para a comunidade?"
                        content="Somos um negócio do setor 2.5, comprometido não apenas em fabricar instrumentos musicais percussivos, mas em transformar vidas. Empregamos jovens da comunidade, oferecendo oportunidades e um futuro com mais possibilidades, além de promover o desenvolvimento social e econômico."
                        borderColor={colorLine}
                    />

                    <ExpandableItem
                        title="Que tipo de madeira a Ripafactory utiliza em seus instrumentos?"
                        content="Utilizamos o Paricá (Schizolobium amazonicum), uma madeira leve e de crescimento rápido, que é essencial para o reflorestamento de áreas degradadas."
                        borderColor={colorLine}
                    />



                </div>
            </div>

        </div>

    );
}

export default Faq;